import { Building2, Car, Plus, Search } from "lucide-react";
import { Link } from "react-router-dom";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useAssets } from "../data/assets-platform-data";

function tone(status: string): "success" | "warning" | "danger" | "neutral" {
  if (status === "AVAILABLE") return "success";
  if (status === "MAINTENANCE") return "warning";
  if (status === "INACTIVE") return "danger";
  return "neutral";
}

export function AssetsPage() {
  const query = useAssets();
  if (query.isLoading) return <Skeleton className="dashboard-skeleton" />;
  if (query.error) {
    return (
      <EmptyState
        title="Não foi possível carregar o patrimônio"
        description={query.error.message}
      />
    );
  }

  return (
    <Card
      title="Patrimônio"
      description="Veículos e imóveis controlados em uma única base."
      action={
        <div className="inline-actions">
          <Link to="/operacoes/nova?tipo=vehicle">
            <Button variant="secondary">
              <Plus size={16} /> Veículo
            </Button>
          </Link>
          <Link to="/operacoes/nova?tipo=property">
            <Button>
              <Plus size={16} /> Imóvel
            </Button>
          </Link>
        </div>
      }
    >
      <div className="toolbar">
        <div className="search-box">
          <Search size={17} />
          <input
            aria-label="Buscar ativos"
            placeholder="Código, modelo, placa, imóvel ou endereço"
          />
        </div>
        <select aria-label="Filtrar tipo de ativo">
          <option>Todos os ativos</option>
          <option>Veículos</option>
          <option>Imóveis</option>
        </select>
      </div>

      <DataTable
        rows={query.data ?? []}
        getKey={(row) => row.id}
        columns={[
          {
            key: "type",
            header: "Tipo",
            render: (row) => (row.type === "VEHICLE" ? <Car size={18} /> : <Building2 size={18} />),
          },
          { key: "code", header: "Código", render: (row) => row.code },
          {
            key: "name",
            header: "Ativo",
            render: (row) => (
              <div className="strong-link">
                {row.name}
                <small>{row.description}</small>
              </div>
            ),
          },
          {
            key: "status",
            header: "Situação",
            render: (row) => <Badge tone={tone(row.status)}>{row.status}</Badge>,
          },
          { key: "value", header: "Valor", render: (row) => row.value },
        ]}
      />
    </Card>
  );
}
